// extracted by mini-css-extract-plugin
module.exports = {"subjects":"_cc","subject__list":"_cd","show_all_subjects":"_ce","subject__item":"_cf","subject__name":"_cg","show_more":"_ch","subject__img":"_ci"};